export default {
  getContactById: (state) => state.contacts.find((c) => c.id === state.contact?.id),
};
